import { Transformer } from "@services/api";

import { Image } from "./Image";
import { Item } from "./Item";
import { VariantAllocation } from "./VariantAllocation";
import { VariantOption } from "./VariantOption";

/**
 * Known custom fields. Plugins augment this interface for fields they own.
 */
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface VariantCustomFields {}

export type Variant = {
  id: string;
  variantSku: string;
  isActive: boolean;
  isDefault: boolean;
  orderPosition: number;
  relationshipNames: ["selectedVariantOptions", "variantAllocations"];
  selectedVariantOptions: VariantOption[];
  upcharge: number;
  variantAllocations: VariantAllocation[];
  availableToOrderQty?: number;
  cachedWarehouseQty?: number;
  quantityOnHand?: number;
  externalWarehouseId?: string;
  reorderThreshold: number;
  globalAvailableToOrderQty: number;
  /** Used by catalog / place-order / order-set pages for sold-out UX. */
  pastTheCap?: boolean;
  item: Item;
  imageId: number | null;
  customFields: VariantCustomFields;
  // Not always loaded
  image?: Image;
};

const variantTransformer: Transformer = {
  type: ["variant", "variants"],
  deserialize: (data) => ({
    ...data,
    upcharge: data.upcharge ? Number(data.upcharge) : 0,
    customFields: data.customFields ?? {},
  }),
  serialize: (data) => ({
    ...data,
  }),
};

export default variantTransformer;
